import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Button from "./Button";

interface TrackingWarningPopupProps {
  open: boolean;
  orderIds: string[];
  onClose: () => void;
  onConfirm: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const TrackingWarningPopup: React.FC<TrackingWarningPopupProps> = ({
  open,
  orderIds,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          p: 0,
          border: "2px solid rgba(27, 27, 27, 0.3)",
        },
      }}
    >
      <DialogContent
        sx={{
          p: 2,
          background: "linear-gradient(to right,rgb(21, 28, 17), #151d23)",
        }}
      >
        <Box gap={2}>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1, fontSize: "16px" }}>
            Tracking Number Already in Use
          </Typography>

          <Typography variant="body2" sx={{ color: colors.grey[400], fontSize: "14px" }}>
            This tracking number is already associated with the following order(s):
          </Typography>

          {/* Chips */}
          <Box sx={{ my: 1.5, display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {orderIds.map((id) => (
              <Box
                key={id}
                sx={{
                  px: 1.2,
                  py: 0.3,
                  borderRadius: "6px",
                  backgroundColor: "rgba(100, 91, 9, 0.25)",
                  border: `1px solid ${colors.warning[400]}`,
                  color: colors.warning[300],
                  fontSize: "12px",
                  fontWeight: 600,
                  letterSpacing: "0.4px",
                }}
              >
                {id}
              </Box>
            ))}
          </Box>

          <Typography variant="body2" sx={{ color: colors.grey[400], fontSize: "14px" }}>
            Do you want to continue and use it for this order as well?
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "end", marginTop: "16px" }}>
          <Button sx={{ marginRight: "5px" }} onClick={onConfirm} color="success">
            Confirm
          </Button>
          <Button onClick={onClose} color="warning">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default TrackingWarningPopup;